import styled from "styled-components";

export const Button = styled.button`
    border-radius: 100px;
    background: #FFF;
    box-sizing: border-box;
    padding: 6px 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    text-wrap: nowrap;
    font-size: 13px;
`;